import cookie from 'js-cookie';
import type { User } from 'types/User';
import * as uuid from 'uuid';

import facebook from '~/services/facebook';
import facebookPixel from '~/services/facebook.pixel';
import { sha256 } from '~/utils/hash';
import { getEntrypoint, getPageSeq } from '~/utils/navigationContext';

import UserEvent from './UserEvent';

type EventData = {
  clientIp: string | null;
  isBot: boolean;
  pageType: string;
  url: string;
  user: User;
};

class PageViewEvent extends UserEvent<EventData> {
  private readonly pageViewId = uuid.v4();

  async sendToFacebook() {
    const eventId = uuid.v4();

    await facebookPixel.fireEvent({
      eventID: eventId,
      eventName: facebookPixel.StandardEventNames.PageView
    });

    const hashedProfile = await facebook.getHashedProfile(
      this.data.user.profile
    );

    const externalId = await sha256(this.data.user.id ?? 'guest');

    const serverEventData = [
      {
        action_source: 'website',
        event_id: eventId,
        event_name: facebookPixel.StandardEventNames.PageView,
        event_source_url: window.location.href,
        event_time: Math.floor(Date.now() / 1000),
        user_data: {
          client_ip_address: this.data.clientIp,
          client_user_agent: navigator.userAgent,
          external_id: externalId,
          fbc: cookie.get('_fbc'),
          fbp: cookie.get('_fbp'),
          ...hashedProfile
        }
      }
    ];

    this.serverEvents.push({ data: serverEventData, type: 'facebook' });
  }

  collectServerEvents() {
    const pageSeq = getPageSeq();
    const isEntry = pageSeq <= 1;

    this.serverEvents.push({
      data: {
        entry_source: isEntry ? getEntrypoint() : undefined,
        is_entry: isEntry,
        page_location: window.location.href,
        page_path: window.location.pathname,
        page_seq: pageSeq,
        page_type: this.data.pageType,
        page_view_id: this.pageViewId,
        referrer: document.referrer || undefined,
        url: this.data.url,
        view_ts: Date.now()
      },
      type: 'page_view'
    });
  }
}

export default PageViewEvent;
